
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-invoicing",
      function () {
        return require("private-next-pages/e-invoicing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e-invoicing"])
      });
    }
  